(() => {
  const host = window.location.hostname;
  const isPT = host.includes('mtb.leatt.pt');
  if (!isPT) return;

  function injectPTCss() {
    if (document.getElementById('pt-i18n-overrides-style')) return;

    const style = document.createElement('style');
    style.id = 'pt-i18n-overrides-style';
    style.textContent = `
      .buy-buttons-row button.gw-button-widget::before,
      .buy-buttons-row button.gw-button-widget::after {
        content: "" !important;
        display: none !important;
        animation: none !important;
        transition: none !important;
        transform: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  function translatePoints() {
    const container = document.querySelector('.joy-points-calculator__block');
    if (!container) return;

    const span = container.querySelector('span');
    if (!span) return;

    const text = (span.textContent || '').trim();
    const match = text.match(/(\d+)/);
    if (!match) return;

    const points = match[1];

    const newText = `Receba ${points} pontos por comprar este artigo.`;
    if (span.textContent.trim() === newText) {
      span.dataset.i18nDone = "true";
      return;
    }

    span.textContent = newText;
    span.dataset.i18nDone = "true";
  }

  function forceNotifyButtonText() {
    const btn = document.querySelector('.buy-buttons-row button.gw-button-widget');
    if (!btn) return;

    const newText = 'Avise-me quando estiver disponível';
    if (btn.textContent.trim() === newText) {
      btn.dataset.i18nDone = 'true';
      return;
    }

    btn.textContent = newText;
    btn.dataset.i18nDone = 'true';
  }

  function applyAll() {
    injectPTCss();
    translatePoints();
    forceNotifyButtonText();
  }

  applyAll();

  const observer = new MutationObserver(() => {
    applyAll();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();